import React from 'react';
import {useField} from 'formik';
import Checkbox, {Props as CheckboxProps} from 'shared/components/checkbox';

/**
  For use in Formik forms.

  Usage example:
  <FormikCheckbox name="save" label="Save automatically?" />
*/

const FormikCheckbox = (props: {name: string} & CheckboxProps) => {
  const [field] = useField({name: props.name, type: 'checkbox'});
  return (
    <Checkbox
      {...props}
      {...field}
      {...(props.onChange && {
        onChange: (e) => {
          field.onChange(e);
          props.onChange?.(e);
        },
      })}
    />
  );
};

export default FormikCheckbox;
